import { getUserDisplayName } from 'shared-helpers/common';
import { useReduxState } from 'hooks';
import { getFormattedDate } from 'lib/common';
import { Link, TimeIndicator, User } from 'components/common';

import type { UserWithBasicData } from 'shared-types';

interface Props {
  addedByString?: string;
  date: string;
  enableUserLink?: boolean;
  user?: UserWithBasicData;
}

const AchievementItemAddedBy = ({
  addedByString,
  date,
  enableUserLink,
  user
}: Props) => {
  const { language, messages, serverConfig, theme } = useReduxState();

  return (
    <div className="added">
      {user ? (
        <User
          showEmail={false}
          showNameOrUsername={false}
          size="tiny"
          style={{ marginRight: 5 }}
          user={user}
        />
      ) : null}
      <div className="added-text">
        {`${addedByString || messages.commonAddedBy} `}
        {user && enableUserLink ? (
          <Link
            as={`/users/${user.id}`}
            href="/users/[userId]"
            linkColor="inherit"
            text={getUserDisplayName({
              messages,
              serverConfig,
              user
            })}
          />
        ) : user ? (
          <span>
            {getUserDisplayName({
              messages,
              serverConfig,
              user
            })}
          </span>
        ) : (
          messages.activitiesTextUnknownUser
        )}{' '}
        <span
          aria-label={getFormattedDate({ date })}
          data-tooltip={getFormattedDate({ date })}
          style={{ textTransform: 'lowercase' }}
        >
          <TimeIndicator language={language} timeString={date} />
        </span>
      </div>

      <style jsx>{`
        .added-text {
          color: ${theme.textColorLighter};
          display: inline-block;
          font-size: 1.3rem;
          font-weight: 600;
          vertical-align: middle;
        }
      `}</style>
    </div>
  );
};

export default AchievementItemAddedBy;
